var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  blackoutdatesCollection.push([2023, 11, 24, 'inverted'])
  blackoutdatesCollection.push([2023, 11, 31, 'inverted'])
  picker.set('disable', blackoutdatesCollection);

}

var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  console.log(selectedDay, selectedDate, selectedMonth);
  if(
    (selectedDate.getDate() === 27 && selectedMonth === 10 && selectedDate.getFullYear() === 2024)
    || (selectedDate.getDate() === 24 && selectedMonth === 11 && selectedDate.getFullYear() === 2024)
    || (selectedDate.getDate() === 31 && selectedMonth === 11 && selectedDate.getFullYear() === 2024)
    ) {  
    timepicker.set('min',[11, 0]); 
    timepicker.set('max',[12, 30]);
  }
	
}